import React from "react";
import {
	Box,
	Card,
	CardContent,
	CardHeader,
	Divider,
	Paper,
	Skeleton
} from "@mui/material";

const LastApplicationNoteTakenSkeleton: React.FC = () => {
	return (
		<Card
			component={Paper}
			elevation={0}
			sx={{
				margin: "16px",
				borderRadius: "8px"
			}}
		>
			<CardHeader
				title={
					<Box>
						{/* Title skeleton */}
						<Skeleton variant="text" width={200} height={32} sx={{ mb: 1 }} />

						{/* Subtitle skeleton */}
						<Skeleton variant="text" width={300} height={20} sx={{ mb: 0.5 }} />

						{/* Subject skeleton */}
						<Skeleton variant="text" width={150} height={20} />
					</Box>
				}
			/>
			<Divider />
			<CardContent>
				{/* Content skeleton - multiple lines */}
				<Skeleton variant="text" width="100%" height={20} sx={{ mb: 0.5 }} />
				<Skeleton variant="text" width="95%" height={20} sx={{ mb: 0.5 }} />
				<Skeleton variant="text" width="80%" height={20} sx={{ mb: 1 }} />

				{/* Read more link skeleton */}
				<Skeleton variant="text" width={80} height={16} />
			</CardContent>
		</Card>
	);
};

export default LastApplicationNoteTakenSkeleton;
